import Button from "../button";
import ApplyQrInfoCard, { type ApplyQrInfoRow } from "./ApplyQrInfoCard";

/* 현장 인증 완료 화면.
 * QR 화면을 닫을 때 인증이 확인된 경우에만 이어서 노출한다.
 * 표시 전용이라 조회하지 않고 보여줄 값만 받는다.
 */
interface TournamentQrResultModalProps extends ModalComponentProps {
  title: string;
  rows: ApplyQrInfoRow[];
}

export default function TournamentQrResultModal({
  close,
  title,
  rows,
}: TournamentQrResultModalProps) {
  return (
    <div className="flex h-full flex-col bg-[#f2f2f7]">
      <div className="flex flex-1 min-h-0 flex-col items-center justify-center gap-[20px] overflow-y-auto px-[12px] py-[20px]">
        <div className="flex w-full flex-col items-center gap-[12px]">
          <div className="bg-[#ff3b30] size-12 rounded-full flex items-center justify-center">
            <img className="w-5 h-3.5" src="/icons/ic-check.webp" />
          </div>
          <p className="w-full text-center text-3xl font-medium text-black break-keep">
            {title}
          </p>
        </div>

        <ApplyQrInfoCard rows={rows} className="bg-white" />
      </div>

      <div className="shrink-0 p-[12px] pb-[calc(12px+var(--safe-area-inset-bottom))] bg-white">
        <Button
          className="w-full font-normal"
          variant="white"
          label="닫기"
          onClick={close}
        />
      </div>
    </div>
  );
}
